import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are speech recognition services?",
    answer: `<p>Speech recognition, usually referred to as automatic speech recognition (ASR), computer speech recognition, or speech-to-text, involves the ability of a software program to convert human speech into text format.</p>`,
  },
  {
    question: "How do you develop a speech recognition system?",
    answer: `<p>When developing a speech recognition system, there are several basic audio properties we need to consider:</p>
    <ul>
    <li>Audio file format (mp3, wav, flac, etc.)</li>
     <li>Number of channels (stereo or mono)</li>
      <li>Sample rate value (8kHz, 16kHz, etc.)</li>
       <li>Bitrate (32 kbit/s, 128 kbit/s, etc.)</li>
       <li>Duration of the audio clips.</li>
    </ul>`,
  },
  {
    question: "What problem does speech recognition solve?",
    answer: `<p>As most people speak faster than they write, speech recognition is a convenient solution that enables a person to input words into a document without being slowed down in the process. This speed is what makes many people run for it when in need of its services. On the other hand, typing is also handicapping to the communication process since it is time-consuming.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Speech Recognition FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
